export default "__VITE_ASSET__Jtxne$gm__"